import Main from "../Main";
import animateenter from "./events/animate-enter";
import animateleave from "./events/animate-leave";
import blur from "./events/blur";
import change from "./events/change";
import check from "./events/check";
import classadded from "./events/class-added";
import classremoved from "./events/class-removed";
import click from "./events/click";
import focus from "./events/focus";
import focusin from "./events/focus-in";
import focusout from "./events/focus-out";
import pointerdown from "./events/pointer-down";
import pointerenter from "./events/pointer-enter";
import pointerleave from "./events/pointer-leave";
import pointermove from "./events/pointer-move";
import pointerover from "./events/pointer-over";
import pointerup from "./events/pointer-up";
import referenceenter from "./events/reference-enter";
import referenceleave from "./events/reference-leave";
import scroll from "./events/scroll";
import timeoutenter from "./events/timeout-enter";
import timeoutleave from "./events/timeout-leave";
import uncheck from "./events/uncheck";
import viewportenter from "./events/viewport-enter";
import viewportleave from "./events/viewport-leave";

/**
 * Add events list to `this.events` map
 * @this {MainClassProps}
 */
Main.prototype.addEvents = function () {
  /** @type {EventListProps} */
  this.on = new Map([
    ["pointerenter", pointerenter],
    ["pointerleave", pointerleave],
    ["touchstart", pointerenter],
    ["animateenter", animateenter],
    ["animateleave", animateleave],
    ["pointerover", pointerover],
    ["pointerdown", pointerdown],
    ["pointerup", pointerup],
    ["pointermove", pointermove],
    ["touchmove", pointermove],
    ["click", click],
    ["active", pointerdown],
    ["focus", focus],
    ["blur", blur],
    ["focusin", focusin],
    ["focusout", focusout],
    ["change", change],
    ["scroll", scroll],
    ["viewportenter", viewportenter],
    ["viewportleave", viewportleave],
    ["timeoutenter", timeoutenter],
    ["timeoutleave", timeoutleave],
    ["referenceenter", referenceenter],
    ["referenceleave", referenceleave],
  ]);

  /** This prevents from typescript error */
  this.on.set("check", check);
  this.on.set("uncheck", uncheck);
  this.on.set("classadded", classadded);
  this.on.set("classremoved", classremoved);
};

export default Main.prototype.addEvents;
